import React from 'react';
import MetaData from '@minecraft.meta-data';
import appConfig from '@consumer-talent.config/appConfig';

const Meta = ({ title }: { title?: string }) => {
  return <MetaData title={title || appConfig.companyName} />;
};

export default Meta;
